import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import TransitionGroup from 'react-transition-group/TransitionGroup'
import uuid from 'uuid/v4'
import breakpoint from 'tools/styled-components-breakpoint'
import Div from 'components/Div'
import { toastController, TOAST_EVENTS } from './ToastController'
import Toast from './Toast'

const Container = styled(Div)`
  position: fixed;
  top: 0;
  right: 0;
  width: 100%;
  height: 0;
  z-index: 11;
  ${breakpoint('desktop')`
    width: 400px;
    top: 40px;
    right: 20px;
  `}
`

class ToastContainer extends React.Component {
  static propTypes = {
    className: PropTypes.string,
    maxToasts: PropTypes.number
  }

  static defaultProps = {
    maxToasts: 2
  }

  constructor (props) {
    super(props)
    this.state = {
      toastById: {},
      allToasts: []
    }
  }

  componentDidMount () {
    toastController.on(TOAST_EVENTS.SHOW, this.show)
  }

  componentWillUnmount () {
    toastController.off(TOAST_EVENTS.SHOW, this.show)
  }

  show = (toast, options) => {
    const toastId = uuid()
    const { maxToasts } = this.props
    const { allToasts, toastById } = this.state

    this.setState({
      allToasts: allToasts.length === maxToasts ? [ toastId, ...allToasts ].slice(0, -1) : [ toastId, ...allToasts ],
      toastById: { ...toastById, [toastId]: { content: toast, options } }
    })
  }

  close = (toastId, onClosedCallback) => {
    toastController.once(
      TOAST_EVENTS.CLOSED,
      (id) => id === toastId && typeof onClosedCallback === 'function' && onClosedCallback()
    )

    const { allToasts, toastById } = this.state
    delete toastById[toastId]

    this.setState({
      allToasts: allToasts.filter(id => id !== toastId),
      toastById
    })
  }

  renderToasts = () => {
    const { allToasts, toastById } = this.state

    return allToasts.map((toastId) => (
      <Toast {...toastById[toastId].options} key={toastId} toastId={toastId} closeToast={(onClosedCallback) => this.close(toastId, onClosedCallback)}>
        {toastById[toastId].content}
      </Toast>
    ))
  }

  render () {
    const { className } = this.props

    return (
      <Container className={className}>
        <TransitionGroup>
          {this.renderToasts()}
        </TransitionGroup>
      </Container>
    )
  }
}

export default ToastContainer
